const Theme = {
    body_background_color: '#C37DB3',

    logo_image_url: 'mouvementdiapason.png',
    logo_height: 200,

    header_padding: '0',
    header_border_color: '#FFF',

    button_color: '#8FCEC7',

    button_half_border_color: '#8FCEC7',

    text_font: `'Freigeist', sans-serif`,

    title_font: `'Freigeist', sans-serif`,

    subtitle_font: `'Freigeist', sans-serif`,

    footer_border_color: '#FFF',

  }

  export default Theme
